import { __decorate, __extends } from "tslib";
import { inject, observer } from 'mobx-react';
import React from 'react';
import { deletePush } from '../api/push';
import { customConfirm } from '../utils/utils';
import { Button } from './Button';
import S from './PushItem.styl';
var PushItem = /** @class */ (function (_super) {
    __extends(PushItem, _super);
    function PushItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
        };
        _this.deleteItem = function () {
            var i18n = _this.props.store.i18n;
            var notification = _this.props.notification;
            if (notification) {
                customConfirm(i18n.extrasDeleteSummary, _this.props.store, function (success) {
                    if (success) {
                        _this.setState({ loading: true });
                        var request = {
                            id: notification.id,
                        };
                        deletePush(request).then(function () {
                            _this.setState({ loading: false });
                            _this.isUpdated();
                        }).catch(function (error) {
                            _this.setState({ loading: false });
                            alert(error);
                        });
                    }
                });
            }
        };
        _this.isUpdated = function () {
            if (_this.props.isUpdated) {
                _this.props.isUpdated();
            }
        };
        return _this;
    }
    PushItem.prototype.componentDidMount = function () {
        // Did Mount
    };
    PushItem.prototype.render = function () {
        var props = this.props;
        var notification = props.notification;
        var i18n = props.store.i18n;
        return (React.createElement("div", { className: S.pushItem }, notification ?
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: S.tableCell + " titleCell" }, notification === null || notification === void 0 ? void 0 : notification.title),
                React.createElement("div", { className: S.action },
                    React.createElement(Button, { className: S.deleteButton, type: "button", onClick: this.deleteItem }, i18n.actionDelete)))
            :
                React.createElement(React.Fragment, null)));
    };
    PushItem = __decorate([
        inject('store'),
        observer
    ], PushItem);
    return PushItem;
}(React.Component));
export { PushItem };
